export default __webpack_public_path__ + "static/media/Quicksilvered Leggings.4a2348d8.jpg";